/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreateManualPositionRequestMatching } from '@coin/shared/core/util-models-v2';
import { CreateTeamMemberAvailabilityPeriod } from '@coin/shared/core/util-models-v2';
import { DepartmentAdjustments } from '@coin/shared/core/util-models-v2';
import { DepartmentBreadcrumbItem } from '@coin/shared/core/util-models-v2';
import { FieldValues } from '@coin/shared/core/util-models-v2';
import { PageOfDepartment } from '@coin/shared/core/util-models-v2';
import { PageOfDepartmentAdjustments } from '@coin/shared/core/util-models-v2';
import { PageOfPositionRequestMatchingEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PageOfTeamMember } from '@coin/shared/core/util-models-v2';
import { PageOfTeamMemberAvailabilityAggregation } from '@coin/shared/core/util-models-v2';
import { PageOfTeamMemberAvailabilityPeriod } from '@coin/shared/core/util-models-v2';
import { PositionRequest } from '@coin/shared/core/util-models-v2';
import { PositionRequestMatching } from '@coin/shared/core/util-models-v2';
import { Report } from '@coin/shared/core/util-models-v2';
import { ResetPositionRequestMatching } from '@coin/shared/core/util-models-v2';
import { TeamMemberDetails } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateDepartmentAdjustments } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequestFinancialData } from '@coin/shared/core/util-models-v2';
import { UpdateTeamMemberAvailability } from '@coin/shared/core/util-models-v2';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface AcceptMatchingPositionRequestMatchingParams {
  employeeId?: string;
  positionRequestId?: string;
}

export interface CreateManualMatchingPositionRequestMatchingParams {
  createManualPositionRequestMatching?: CreateManualPositionRequestMatching;
}

export interface CreateTeamMemberAvailabilityPeriodsParams {
  teamMemberId: string;
  disableElevatedPermissions?: boolean;
  createTeamMemberAvailabilityPeriod?: CreateTeamMemberAvailabilityPeriod;
}

export interface DeleteDepartmentAdjustmentDepartmentAdjustmentsParams {
  /** The department of which the adjustments should be returned of. */
  department: string;
  /** The cost center of which the adjustments should be returned of. */
  costCenter?: string;
  /** The legal entity of which the adjustments should be returned of. */
  areCode?: string;
  /** The depth structure of which the adjustments should be returned of. */
  depthStructure?: string;
  disableElevatedPermissions?: boolean;
}

export interface DeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsParams {
  teamMemberId: string;
  id: string;
  disableElevatedPermissions?: boolean;
}

export interface ExportDepartmentAnalyticsReportExportParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  filename?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface ExportListViewTeamMembersExportParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The organisation of which the team members should be returned of. */
  departments?: Array<string>;
  /** The organisation which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  priorityEmployeeId?: string;
  priorityPositionRequestId?: string;
  filename?: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface ExportTeamAnalyticsReportExportParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  filename?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface GetAvailableEmployeesForMatchingPositionRequestMatchingParams {
  positionRequestId: string;
  /** Search term to search an employee by firstname, lastname, or GID */
  searchTerm?: string;
  page?: number;
  size?: number;
}

export interface GetDepartmentAdjustmentDepartmentAdjustmentsParams {
  /** The department of which the adjustments should be returned of. */
  department: string;
  /** The year and month to first include adjustments for. */
  startDate: string;
  /** The year and month to no longer include adjustments for. */
  endDate: string;
  /** The cost center of which the adjustments should be returned of. */
  costCenter?: string;
  /** The legal entity of which the adjustments should be returned of. */
  areCode?: string;
  /** The depth structure of which the adjustments should be returned of. */
  depthStructure?: string;
  disableElevatedPermissions?: boolean;
}

export interface GetDepartmentAdjustmentsDepartmentAdjustmentsParams {
  /** The year and month to first include adjustments for. */
  startDate: string;
  /** The year and month to no longer include adjustments for. */
  endDate: string;
  /** The department of which the adjustments should be returned of. */
  departments?: Array<string>;
  /** The organisation which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  businessArea?: Array<string>;
  /** If values should be shown as FTE or HC */
  headcountDisplayType?: 'Headcount' | 'FullTimeEquivalent';
  /** The cost center of which the adjustments should be returned of. */
  costCenter?: Array<string>;
  /** The legal entity of which the adjustments should be returned of. */
  areCode?: Array<string>;
  /** The depth structure of which the adjustments should be returned of. */
  depthStructure?: Array<string>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface GetDepartmentBreadcrumbDepartmentBreadcrumbParams {
  orgCode: string;
}

export interface GetDepartmentReportAnalyticsFieldValuesParams {
  field:
    | 'AreCode'
    | 'OrgCode'
    | 'BusinessArea'
    | 'CountryTitle'
    | 'Region'
    | 'Location'
    | 'Gid'
    | 'CostCenter'
    | 'DepthStructure'
    | 'DepthStructureText'
    | 'ContractStatus'
    | 'WorkforceType';
  /** The organisation of which field values should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface GetDepartmentReportAnalyticsReportsParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  headcountDisplayType: 'Headcount' | 'FullTimeEquivalent';
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  changeDisplayType?: 'Absolute' | 'Percentage';
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface GetDetailsTeamMembersParams {
  id: string;
  startDate: string;
  endDate: string;
  disableElevatedPermissions?: boolean;
}

export interface GetMatchingsForPositionRequestPositionRequestMatchingParams {
  positionRequestId: string;
  /** Parameter to optionally filter by Acknowledge State */
  acknowledgeStatesFilter?: Array<'Open' | 'Accepted' | 'Rejected' | 'Irrelevant'>;
  /** Search term to search an employee by firstname, lastname, or GID */
  searchTerm?: string;
}

export interface GetTeamReportAnalyticsFieldValuesParams {
  field:
    | 'AreCode'
    | 'OrgCode'
    | 'BusinessArea'
    | 'CountryTitle'
    | 'Region'
    | 'Location'
    | 'Gid'
    | 'CostCenter'
    | 'DepthStructure'
    | 'DepthStructureText'
    | 'ContractStatus'
    | 'WorkforceType';
  /** The organisation of which field values should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface GetTeamReportAnalyticsReportsParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  headcountDisplayType: 'Headcount' | 'FullTimeEquivalent';
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  changeDisplayType?: 'Absolute' | 'Percentage';
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewQueryBusinessAreasBusinessAreasParams {
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface IsReadOnlyModeUltimoPhaseParams {
  disableElevatedPermissions?: boolean;
}

export interface PageAnalyticsDepartmentCodesAnalyticsDepartmentCodesParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The business-areas to query departments of. */
  businessArea?: Array<string>;
  search?: string;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface PageTeamDepartmentCodesTeamDepartmentCodesParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The business-areas to query departments of. */
  businessArea?: Array<string>;
  search?: string;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface PostUltimoPhaseStartDateOverrideUltimoPhaseParams {
  body?: string;
}

export interface QueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationParams {
  /** The organisation of which the departments should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  headcountDisplayType: 'Headcount' | 'FullTimeEquivalent';
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  changeDisplayType?: 'Absolute' | 'Percentage';
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface QueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The organisation of which the team members should be returned of. */
  departments?: Array<string>;
  /** The organisation which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  priorityEmployeeId?: string;
  priorityPositionRequestId?: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface QueryFieldValuesTeamMemberFieldValuesParams {
  field:
    | 'AreCode'
    | 'OrgCode'
    | 'BusinessArea'
    | 'CountryTitle'
    | 'Region'
    | 'Location'
    | 'Gid'
    | 'CostCenter'
    | 'DepthStructure'
    | 'DepthStructureText'
    | 'ContractStatus'
    | 'WorkforceType';
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  /** The organisation of which the team members should be returned of. */
  departments?: Array<string>;
  /** The department which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface QueryIrrelevantAnalyticsTeamMemberParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface QueryIrrelevantPositionRequestsAnalyticsTeamMemberParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface QueryRelevantAnalyticsTeamMemberParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface QueryRelevantPositionRequestsAnalyticsTeamMemberParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface QueryTeamMemberAvailabilityPeriodsParams {
  teamMemberId: string;
  startDate: string;
  endDate: string;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface QueryTeamMembersParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  /** The department of which the team members should be returned of. */
  departments?: Array<string>;
  /** The department which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface RejectMatchingPositionRequestMatchingParams {
  employeeId?: string;
  positionRequestId?: string;
}

export interface ResetMatchingPositionRequestMatchingParams {
  resetPositionRequestMatching?: ResetPositionRequestMatching;
}

export interface UpdateDepartmentAdjustmentsDepartmentAdjustmentsParams {
  disableElevatedPermissions?: boolean;
  updateDepartmentAdjustments?: UpdateDepartmentAdjustments;
}

export interface UpdateManyTeamMemberAvailabilitiesTeamMembersParams {
  id: string;
  startDate: string;
  endDate: string;
  disableElevatedPermissions?: boolean;
  updateTeamMemberAvailability?: Array<UpdateTeamMemberAvailability>;
}

export interface UpdatePositionRequestFinancialDataOverviewPositionRequestParams {
  id: string;
  updatePositionRequestFinancialData?: UpdatePositionRequestFinancialData;
}

@Injectable({
  providedIn: 'root'
})
export class HeadcountOverviewService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acceptMatchingPositionRequestMatching(
    requestParameters?: AcceptMatchingPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public acceptMatchingPositionRequestMatching(
    requestParameters?: AcceptMatchingPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public acceptMatchingPositionRequestMatching(
    requestParameters?: AcceptMatchingPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public acceptMatchingPositionRequestMatching(
    requestParameters?: AcceptMatchingPositionRequestMatchingParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    const positionRequestId = requestParameters?.positionRequestId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (employeeId !== undefined && employeeId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>employeeId, 'employeeId');
    }
    if (positionRequestId !== undefined && positionRequestId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionRequestId,
        'positionRequestId'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching/accept`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createManualMatchingPositionRequestMatching(
    requestParameters?: CreateManualMatchingPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public createManualMatchingPositionRequestMatching(
    requestParameters?: CreateManualMatchingPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public createManualMatchingPositionRequestMatching(
    requestParameters?: CreateManualMatchingPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public createManualMatchingPositionRequestMatching(
    requestParameters?: CreateManualMatchingPositionRequestMatchingParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const createManualPositionRequestMatching = requestParameters?.createManualPositionRequestMatching;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createManualPositionRequestMatching,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: CreateTeamMemberAvailabilityPeriodsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: CreateTeamMemberAvailabilityPeriodsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: CreateTeamMemberAvailabilityPeriodsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: CreateTeamMemberAvailabilityPeriodsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const teamMemberId = requestParameters?.teamMemberId;
    if (teamMemberId === null || teamMemberId === undefined) {
      throw new Error(
        'Required parameter teamMemberId was null or undefined when calling createTeamMemberAvailabilityPeriods.'
      );
    }
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;
    const createTeamMemberAvailabilityPeriod = requestParameters?.createTeamMemberAvailabilityPeriod;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'teamMemberId', value: teamMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availability-periods`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createTeamMemberAvailabilityPeriod,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: DeleteDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: DeleteDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: DeleteDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: DeleteDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling deleteDepartmentAdjustmentDepartmentAdjustments.'
      );
    }
    const costCenter = requestParameters?.costCenter;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (costCenter !== undefined && costCenter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>costCenter, 'CostCenter');
    }
    if (areCode !== undefined && areCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>areCode, 'AreCode');
    }
    if (depthStructure !== undefined && depthStructure !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>depthStructure, 'DepthStructure');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/department-adjustments`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: DeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: DeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: DeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: DeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const teamMemberId = requestParameters?.teamMemberId;
    if (teamMemberId === null || teamMemberId === undefined) {
      throw new Error(
        'Required parameter teamMemberId was null or undefined when calling deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods.'
      );
    }
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'teamMemberId', value: teamMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availability-periods/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/ultimo-phase/start-date-override`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: ExportDepartmentAnalyticsReportExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: ExportDepartmentAnalyticsReportExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: ExportDepartmentAnalyticsReportExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: ExportDepartmentAnalyticsReportExportParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling exportDepartmentAnalyticsReportExport.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling exportDepartmentAnalyticsReportExport.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling exportDepartmentAnalyticsReportExport.'
      );
    }
    const filename = requestParameters?.filename;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/analytics-report-export/department`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportListViewTeamMembersExport(
    requestParameters?: ExportListViewTeamMembersExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportListViewTeamMembersExport(
    requestParameters?: ExportListViewTeamMembersExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportListViewTeamMembersExport(
    requestParameters?: ExportListViewTeamMembersExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportListViewTeamMembersExport(
    requestParameters?: ExportListViewTeamMembersExportParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling exportListViewTeamMembersExport.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error('Required parameter endDate was null or undefined when calling exportListViewTeamMembersExport.');
    }
    const departments = requestParameters?.departments;
    const departmentsExcluding = requestParameters?.departmentsExcluding;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const priorityEmployeeId = requestParameters?.priorityEmployeeId;
    const priorityPositionRequestId = requestParameters?.priorityPositionRequestId;
    const filename = requestParameters?.filename;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (departments) {
      departments.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Departments');
      });
    }
    if (departmentsExcluding) {
      departmentsExcluding.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepartmentsExcluding');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (priorityEmployeeId !== undefined && priorityEmployeeId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>priorityEmployeeId,
        'PriorityEmployeeId'
      );
    }
    if (priorityPositionRequestId !== undefined && priorityPositionRequestId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>priorityPositionRequestId,
        'PriorityPositionRequestId'
      );
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/list-view-team-member-export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportTeamAnalyticsReportExport(
    requestParameters?: ExportTeamAnalyticsReportExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportTeamAnalyticsReportExport(
    requestParameters?: ExportTeamAnalyticsReportExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportTeamAnalyticsReportExport(
    requestParameters?: ExportTeamAnalyticsReportExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportTeamAnalyticsReportExport(
    requestParameters?: ExportTeamAnalyticsReportExportParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling exportTeamAnalyticsReportExport.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling exportTeamAnalyticsReportExport.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error('Required parameter endDate was null or undefined when calling exportTeamAnalyticsReportExport.');
    }
    const filename = requestParameters?.filename;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/analytics-report-export/team`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: GetAvailableEmployeesForMatchingPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfPositionRequestMatchingEmployee>;
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: GetAvailableEmployeesForMatchingPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfPositionRequestMatchingEmployee>>;
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: GetAvailableEmployeesForMatchingPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfPositionRequestMatchingEmployee>>;
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: GetAvailableEmployeesForMatchingPositionRequestMatchingParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    if (positionRequestId === null || positionRequestId === undefined) {
      throw new Error(
        'Required parameter positionRequestId was null or undefined when calling getAvailableEmployeesForMatchingPositionRequestMatching.'
      );
    }
    const searchTerm = requestParameters?.searchTerm;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (searchTerm !== undefined && searchTerm !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchTerm, 'SearchTerm');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/available-employees`;
    return this.httpClient.request<PageOfPositionRequestMatchingEmployee>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<DepartmentAdjustments>;
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<DepartmentAdjustments>>;
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<DepartmentAdjustments>>;
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling getDepartmentAdjustmentDepartmentAdjustments.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling getDepartmentAdjustmentDepartmentAdjustments.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling getDepartmentAdjustmentDepartmentAdjustments.'
      );
    }
    const costCenter = requestParameters?.costCenter;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (costCenter !== undefined && costCenter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>costCenter, 'CostCenter');
    }
    if (areCode !== undefined && areCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>areCode, 'AreCode');
    }
    if (depthStructure !== undefined && depthStructure !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>depthStructure, 'DepthStructure');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/department-adjustments/details`;
    return this.httpClient.request<DepartmentAdjustments>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfDepartmentAdjustments>;
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfDepartmentAdjustments>>;
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfDepartmentAdjustments>>;
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling getDepartmentAdjustmentsDepartmentAdjustments.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling getDepartmentAdjustmentsDepartmentAdjustments.'
      );
    }
    const departments = requestParameters?.departments;
    const departmentsExcluding = requestParameters?.departmentsExcluding;
    const businessArea = requestParameters?.businessArea;
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    const costCenter = requestParameters?.costCenter;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (departments) {
      departments.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Departments');
      });
    }
    if (departmentsExcluding) {
      departmentsExcluding.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepartmentsExcluding');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (headcountDisplayType !== undefined && headcountDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headcountDisplayType,
        'HeadcountDisplayType'
      );
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/department-adjustments`;
    return this.httpClient.request<PageOfDepartmentAdjustments>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: GetDepartmentBreadcrumbDepartmentBreadcrumbParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<DepartmentBreadcrumbItem>>;
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: GetDepartmentBreadcrumbDepartmentBreadcrumbParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<DepartmentBreadcrumbItem>>>;
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: GetDepartmentBreadcrumbDepartmentBreadcrumbParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<DepartmentBreadcrumbItem>>>;
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: GetDepartmentBreadcrumbDepartmentBreadcrumbParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    if (orgCode === null || orgCode === undefined) {
      throw new Error(
        'Required parameter orgCode was null or undefined when calling getDepartmentBreadcrumbDepartmentBreadcrumb.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/department-breadcrumb/${this.configuration.encodeParam({ name: 'orgCode', value: orgCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<Array<DepartmentBreadcrumbItem>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: GetDepartmentReportAnalyticsFieldValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<FieldValues>;
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: GetDepartmentReportAnalyticsFieldValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<FieldValues>>;
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: GetDepartmentReportAnalyticsFieldValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<FieldValues>>;
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: GetDepartmentReportAnalyticsFieldValuesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const field = requestParameters?.field;
    if (field === null || field === undefined) {
      throw new Error(
        'Required parameter field was null or undefined when calling getDepartmentReportAnalyticsFieldValues.'
      );
    }
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling getDepartmentReportAnalyticsFieldValues.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling getDepartmentReportAnalyticsFieldValues.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling getDepartmentReportAnalyticsFieldValues.'
      );
    }
    const search = requestParameters?.search;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/analytics-field-values/department/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: "'AreCode' | 'OrgCode' | 'BusinessArea' | 'CountryTitle' | 'Region' | 'Location' | 'Gid' | 'CostCenter' | 'DepthStructure' | 'DepthStructureText' | 'ContractStatus' | 'WorkforceType'", dataFormat: undefined })}`;
    return this.httpClient.request<FieldValues>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentReportAnalyticsReports(
    requestParameters?: GetDepartmentReportAnalyticsReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Report>;
  public getDepartmentReportAnalyticsReports(
    requestParameters?: GetDepartmentReportAnalyticsReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Report>>;
  public getDepartmentReportAnalyticsReports(
    requestParameters?: GetDepartmentReportAnalyticsReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Report>>;
  public getDepartmentReportAnalyticsReports(
    requestParameters?: GetDepartmentReportAnalyticsReportsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling getDepartmentReportAnalyticsReports.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling getDepartmentReportAnalyticsReports.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling getDepartmentReportAnalyticsReports.'
      );
    }
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    if (headcountDisplayType === null || headcountDisplayType === undefined) {
      throw new Error(
        'Required parameter headcountDisplayType was null or undefined when calling getDepartmentReportAnalyticsReports.'
      );
    }
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const changeDisplayType = requestParameters?.changeDisplayType;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (headcountDisplayType !== undefined && headcountDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headcountDisplayType,
        'HeadcountDisplayType'
      );
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (changeDisplayType !== undefined && changeDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>changeDisplayType,
        'ChangeDisplayType'
      );
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/headcount/overview/analytics-reports/department`;
    return this.httpClient.request<Report>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDetailsTeamMembers(
    requestParameters?: GetDetailsTeamMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TeamMemberDetails>;
  public getDetailsTeamMembers(
    requestParameters?: GetDetailsTeamMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TeamMemberDetails>>;
  public getDetailsTeamMembers(
    requestParameters?: GetDetailsTeamMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TeamMemberDetails>>;
  public getDetailsTeamMembers(
    requestParameters?: GetDetailsTeamMembersParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getDetailsTeamMembers.');
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error('Required parameter startDate was null or undefined when calling getDetailsTeamMembers.');
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error('Required parameter endDate was null or undefined when calling getDetailsTeamMembers.');
    }
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/details`;
    return this.httpClient.request<TeamMemberDetails>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: GetMatchingsForPositionRequestPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<PositionRequestMatching>>;
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: GetMatchingsForPositionRequestPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<PositionRequestMatching>>>;
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: GetMatchingsForPositionRequestPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<PositionRequestMatching>>>;
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: GetMatchingsForPositionRequestPositionRequestMatchingParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    if (positionRequestId === null || positionRequestId === undefined) {
      throw new Error(
        'Required parameter positionRequestId was null or undefined when calling getMatchingsForPositionRequestPositionRequestMatching.'
      );
    }
    const acknowledgeStatesFilter = requestParameters?.acknowledgeStatesFilter;
    const searchTerm = requestParameters?.searchTerm;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (acknowledgeStatesFilter) {
      acknowledgeStatesFilter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'AcknowledgeStatesFilter'
        );
      });
    }
    if (searchTerm !== undefined && searchTerm !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchTerm, 'SearchTerm');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/matchings`;
    return this.httpClient.request<Array<PositionRequestMatching>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: GetTeamReportAnalyticsFieldValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<FieldValues>;
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: GetTeamReportAnalyticsFieldValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<FieldValues>>;
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: GetTeamReportAnalyticsFieldValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<FieldValues>>;
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: GetTeamReportAnalyticsFieldValuesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const field = requestParameters?.field;
    if (field === null || field === undefined) {
      throw new Error('Required parameter field was null or undefined when calling getTeamReportAnalyticsFieldValues.');
    }
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling getTeamReportAnalyticsFieldValues.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling getTeamReportAnalyticsFieldValues.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling getTeamReportAnalyticsFieldValues.'
      );
    }
    const search = requestParameters?.search;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/analytics-field-values/team/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: "'AreCode' | 'OrgCode' | 'BusinessArea' | 'CountryTitle' | 'Region' | 'Location' | 'Gid' | 'CostCenter' | 'DepthStructure' | 'DepthStructureText' | 'ContractStatus' | 'WorkforceType'", dataFormat: undefined })}`;
    return this.httpClient.request<FieldValues>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTeamReportAnalyticsReports(
    requestParameters?: GetTeamReportAnalyticsReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Report>;
  public getTeamReportAnalyticsReports(
    requestParameters?: GetTeamReportAnalyticsReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Report>>;
  public getTeamReportAnalyticsReports(
    requestParameters?: GetTeamReportAnalyticsReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Report>>;
  public getTeamReportAnalyticsReports(
    requestParameters?: GetTeamReportAnalyticsReportsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling getTeamReportAnalyticsReports.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error('Required parameter startDate was null or undefined when calling getTeamReportAnalyticsReports.');
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error('Required parameter endDate was null or undefined when calling getTeamReportAnalyticsReports.');
    }
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    if (headcountDisplayType === null || headcountDisplayType === undefined) {
      throw new Error(
        'Required parameter headcountDisplayType was null or undefined when calling getTeamReportAnalyticsReports.'
      );
    }
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const changeDisplayType = requestParameters?.changeDisplayType;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (headcountDisplayType !== undefined && headcountDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headcountDisplayType,
        'HeadcountDisplayType'
      );
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (changeDisplayType !== undefined && changeDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>changeDisplayType,
        'ChangeDisplayType'
      );
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/headcount/overview/analytics-reports/team`;
    return this.httpClient.request<Report>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public headcountOverviewQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewQueryBusinessAreasBusinessAreasParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfString>;
  public headcountOverviewQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewQueryBusinessAreasBusinessAreasParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfString>>;
  public headcountOverviewQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewQueryBusinessAreasBusinessAreasParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfString>>;
  public headcountOverviewQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewQueryBusinessAreasBusinessAreasParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/headcount/overview/business-areas`;
    return this.httpClient.request<PageOfString>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public isReadOnlyModeUltimoPhase(
    requestParameters?: IsReadOnlyModeUltimoPhaseParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<boolean>;
  public isReadOnlyModeUltimoPhase(
    requestParameters?: IsReadOnlyModeUltimoPhaseParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<boolean>>;
  public isReadOnlyModeUltimoPhase(
    requestParameters?: IsReadOnlyModeUltimoPhaseParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<boolean>>;
  public isReadOnlyModeUltimoPhase(
    requestParameters?: IsReadOnlyModeUltimoPhaseParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/ultimo-phase`;
    return this.httpClient.request<boolean>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: PageAnalyticsDepartmentCodesAnalyticsDepartmentCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfString>;
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: PageAnalyticsDepartmentCodesAnalyticsDepartmentCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfString>>;
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: PageAnalyticsDepartmentCodesAnalyticsDepartmentCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfString>>;
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: PageAnalyticsDepartmentCodesAnalyticsDepartmentCodesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes.'
      );
    }
    const businessArea = requestParameters?.businessArea;
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/analytics-department-codes`;
    return this.httpClient.request<PageOfString>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: PageTeamDepartmentCodesTeamDepartmentCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfString>;
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: PageTeamDepartmentCodesTeamDepartmentCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfString>>;
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: PageTeamDepartmentCodesTeamDepartmentCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfString>>;
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: PageTeamDepartmentCodesTeamDepartmentCodesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling pageTeamDepartmentCodesTeamDepartmentCodes.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling pageTeamDepartmentCodesTeamDepartmentCodes.'
      );
    }
    const businessArea = requestParameters?.businessArea;
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-department-codes`;
    return this.httpClient.request<PageOfString>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: PostUltimoPhaseStartDateOverrideUltimoPhaseParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<string>;
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: PostUltimoPhaseStartDateOverrideUltimoPhaseParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<string>>;
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: PostUltimoPhaseStartDateOverrideUltimoPhaseParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<string>>;
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: PostUltimoPhaseStartDateOverrideUltimoPhaseParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const body = requestParameters?.body;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/ultimo-phase/start-date-override`;
    return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: body,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfDepartment>;
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfDepartment>>;
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfDepartment>>;
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation.'
      );
    }
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    if (headcountDisplayType === null || headcountDisplayType === undefined) {
      throw new Error(
        'Required parameter headcountDisplayType was null or undefined when calling queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation.'
      );
    }
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const changeDisplayType = requestParameters?.changeDisplayType;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (headcountDisplayType !== undefined && headcountDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headcountDisplayType,
        'HeadcountDisplayType'
      );
    }
    if (changeDisplayType !== undefined && changeDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>changeDisplayType,
        'ChangeDisplayType'
      );
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/departments`;
    return this.httpClient.request<PageOfDepartment>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfTeamMemberAvailabilityAggregation>;
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityAggregation>>;
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityAggregation>>;
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation.'
      );
    }
    const departments = requestParameters?.departments;
    const departmentsExcluding = requestParameters?.departmentsExcluding;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const priorityEmployeeId = requestParameters?.priorityEmployeeId;
    const priorityPositionRequestId = requestParameters?.priorityPositionRequestId;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (departments) {
      departments.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Departments');
      });
    }
    if (departmentsExcluding) {
      departmentsExcluding.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepartmentsExcluding');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (priorityEmployeeId !== undefined && priorityEmployeeId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>priorityEmployeeId,
        'PriorityEmployeeId'
      );
    }
    if (priorityPositionRequestId !== undefined && priorityPositionRequestId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>priorityPositionRequestId,
        'PriorityPositionRequestId'
      );
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/team-members`;
    return this.httpClient.request<PageOfTeamMemberAvailabilityAggregation>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: QueryFieldValuesTeamMemberFieldValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<FieldValues>;
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: QueryFieldValuesTeamMemberFieldValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<FieldValues>>;
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: QueryFieldValuesTeamMemberFieldValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<FieldValues>>;
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: QueryFieldValuesTeamMemberFieldValuesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const field = requestParameters?.field;
    if (field === null || field === undefined) {
      throw new Error(
        'Required parameter field was null or undefined when calling queryFieldValuesTeamMemberFieldValues.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryFieldValuesTeamMemberFieldValues.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryFieldValuesTeamMemberFieldValues.'
      );
    }
    const search = requestParameters?.search;
    const departments = requestParameters?.departments;
    const departmentsExcluding = requestParameters?.departmentsExcluding;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (departments) {
      departments.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Departments');
      });
    }
    if (departmentsExcluding) {
      departmentsExcluding.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepartmentsExcluding');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-member-field-values/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: "'AreCode' | 'OrgCode' | 'BusinessArea' | 'CountryTitle' | 'Region' | 'Location' | 'Gid' | 'CostCenter' | 'DepthStructure' | 'DepthStructureText' | 'ContractStatus' | 'WorkforceType'", dataFormat: undefined })}`;
    return this.httpClient.request<FieldValues>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantAnalyticsTeamMemberParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfTeamMemberAvailabilityAggregation>;
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantAnalyticsTeamMemberParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityAggregation>>;
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantAnalyticsTeamMemberParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityAggregation>>;
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantAnalyticsTeamMemberParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling queryIrrelevantAnalyticsTeamMember.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryIrrelevantAnalyticsTeamMember.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryIrrelevantAnalyticsTeamMember.'
      );
    }
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/team-members/irrelevant`;
    return this.httpClient.request<PageOfTeamMemberAvailabilityAggregation>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfTeamMemberAvailabilityAggregation>;
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityAggregation>>;
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityAggregation>>;
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantPositionRequestsAnalyticsTeamMemberParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling queryIrrelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryIrrelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryIrrelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/team-members/irrelevant-position-requests`;
    return this.httpClient.request<PageOfTeamMemberAvailabilityAggregation>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: QueryRelevantAnalyticsTeamMemberParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfTeamMemberAvailabilityAggregation>;
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: QueryRelevantAnalyticsTeamMemberParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityAggregation>>;
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: QueryRelevantAnalyticsTeamMemberParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityAggregation>>;
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: QueryRelevantAnalyticsTeamMemberParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling queryRelevantAnalyticsTeamMember.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryRelevantAnalyticsTeamMember.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryRelevantAnalyticsTeamMember.'
      );
    }
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/team-members/relevant`;
    return this.httpClient.request<PageOfTeamMemberAvailabilityAggregation>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryRelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfTeamMemberAvailabilityAggregation>;
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryRelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityAggregation>>;
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryRelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityAggregation>>;
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryRelevantPositionRequestsAnalyticsTeamMemberParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling queryRelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryRelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryRelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/team-members/relevant-position-requests`;
    return this.httpClient.request<PageOfTeamMemberAvailabilityAggregation>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: QueryTeamMemberAvailabilityPeriodsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfTeamMemberAvailabilityPeriod>;
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: QueryTeamMemberAvailabilityPeriodsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityPeriod>>;
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: QueryTeamMemberAvailabilityPeriodsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityPeriod>>;
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: QueryTeamMemberAvailabilityPeriodsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const teamMemberId = requestParameters?.teamMemberId;
    if (teamMemberId === null || teamMemberId === undefined) {
      throw new Error(
        'Required parameter teamMemberId was null or undefined when calling queryTeamMemberAvailabilityPeriods.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryTeamMemberAvailabilityPeriods.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryTeamMemberAvailabilityPeriods.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'teamMemberId', value: teamMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availability-periods`;
    return this.httpClient.request<PageOfTeamMemberAvailabilityPeriod>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTeamMembers(
    requestParameters?: QueryTeamMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfTeamMember>;
  public queryTeamMembers(
    requestParameters?: QueryTeamMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfTeamMember>>;
  public queryTeamMembers(
    requestParameters?: QueryTeamMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfTeamMember>>;
  public queryTeamMembers(
    requestParameters?: QueryTeamMembersParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error('Required parameter startDate was null or undefined when calling queryTeamMembers.');
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error('Required parameter endDate was null or undefined when calling queryTeamMembers.');
    }
    const search = requestParameters?.search;
    const departments = requestParameters?.departments;
    const departmentsExcluding = requestParameters?.departmentsExcluding;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (departments) {
      departments.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Departments');
      });
    }
    if (departmentsExcluding) {
      departmentsExcluding.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepartmentsExcluding');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members`;
    return this.httpClient.request<PageOfTeamMember>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateEmployeeAvailability(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<string>;
  public recalculateEmployeeAvailability(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<string>>;
  public recalculateEmployeeAvailability(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<string>>;
  public recalculateEmployeeAvailability(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/headcount/overview/availability/recalculate`;
    return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectMatchingPositionRequestMatching(
    requestParameters?: RejectMatchingPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public rejectMatchingPositionRequestMatching(
    requestParameters?: RejectMatchingPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public rejectMatchingPositionRequestMatching(
    requestParameters?: RejectMatchingPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public rejectMatchingPositionRequestMatching(
    requestParameters?: RejectMatchingPositionRequestMatchingParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    const positionRequestId = requestParameters?.positionRequestId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (employeeId !== undefined && employeeId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>employeeId, 'employeeId');
    }
    if (positionRequestId !== undefined && positionRequestId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionRequestId,
        'positionRequestId'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching/reject`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public resetMatchingPositionRequestMatching(
    requestParameters?: ResetMatchingPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public resetMatchingPositionRequestMatching(
    requestParameters?: ResetMatchingPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public resetMatchingPositionRequestMatching(
    requestParameters?: ResetMatchingPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public resetMatchingPositionRequestMatching(
    requestParameters?: ResetMatchingPositionRequestMatchingParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const resetPositionRequestMatching = requestParameters?.resetPositionRequestMatching;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching/reset`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: resetPositionRequestMatching,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: UpdateDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: UpdateDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: UpdateDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: UpdateDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;
    const updateDepartmentAdjustments = requestParameters?.updateDepartmentAdjustments;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/department-adjustments`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updateDepartmentAdjustments,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: UpdateManyTeamMemberAvailabilitiesTeamMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: UpdateManyTeamMemberAvailabilitiesTeamMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: UpdateManyTeamMemberAvailabilitiesTeamMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: UpdateManyTeamMemberAvailabilitiesTeamMembersParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling updateManyTeamMemberAvailabilitiesTeamMembers.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling updateManyTeamMemberAvailabilitiesTeamMembers.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling updateManyTeamMemberAvailabilitiesTeamMembers.'
      );
    }
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;
    const updateTeamMemberAvailability = requestParameters?.updateTeamMemberAvailability;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availabilities`;
    return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updateTeamMemberAvailability,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: UpdatePositionRequestFinancialDataOverviewPositionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequest>;
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: UpdatePositionRequestFinancialDataOverviewPositionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequest>>;
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: UpdatePositionRequestFinancialDataOverviewPositionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequest>>;
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: UpdatePositionRequestFinancialDataOverviewPositionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling updatePositionRequestFinancialDataOverviewPositionRequest.'
      );
    }
    const updatePositionRequestFinancialData = requestParameters?.updatePositionRequestFinancialData;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/position-request/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<PositionRequest>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updatePositionRequestFinancialData,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }
}
